import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { ChargerDiagnosticsComponent } from './chargers/charger-diagnostics/charger-diagnostics.component';
import { ChargerLayoutComponent } from './chargers/charger-layout/charger-layout.component';
import { ChargerSettingsChargescheduleComponent } from './chargers/charger-settings-chargeschedule/charger-settings-chargeschedule.component';
import { ChargerSettingsInstallerDsoComponent } from './chargers/charger-settings-installer-dso/charger-settings-installer-dso.component';
import { ChargerSettingsInstallerOcppComponent } from './chargers/charger-settings-installer-ocpp/charger-settings-installer-ocpp.component';
import { ChargerSettingsInstallerComponent } from './chargers/charger-settings-installer/charger-settings-installer.component';
import { ChargerSettingsSolarComponent } from './chargers/charger-settings-solar/charger-settings-solar.component';
import { ChargerSettingsUserComponent } from './chargers/charger-settings-user/charger-settings-user.component';
import { ChargerStatusComponent } from './chargers/charger-status/charger-status.component';
import { MyChargersComponent } from './chargers/my-chargers/my-chargers.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MyGroupsComponent } from './groups/my-groups/my-groups.component';
import { SessionHistoryComponent } from './history/session-history/session-history.component';
import { LayoutComponent } from './main/layout/layout.component';
import { NotFoundComponent } from './main/not-found/not-found.component';

export const routes: Routes = [
	{
		path: '',
		component: LayoutComponent,
		children: [
			{ path: 'login', component: LoginComponent },
			{ path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
			{ path: 'chargers', component: MyChargersComponent, canActivate: [authGuard] },
			{
				path: 'charger/:id',
				component: ChargerLayoutComponent,
				canActivate: [authGuard],
				children: [
					{ path: 'status', component: ChargerStatusComponent, canActivate: [authGuard] },
					{ path: 'diagnostics', component: ChargerDiagnosticsComponent, canActivate: [authGuard] },
					{ path: 'settings-user', component: ChargerSettingsUserComponent, canActivate: [authGuard] },
					{ path: 'settings-solar', component: ChargerSettingsSolarComponent, canActivate: [authGuard] },
					{ path: 'settings-charge-schedule', component: ChargerSettingsChargescheduleComponent, canActivate: [authGuard] },
					{ path: 'settings-installer', component: ChargerSettingsInstallerComponent, canActivate: [authGuard] },
					{ path: 'settings-installer-dso', component: ChargerSettingsInstallerDsoComponent, canActivate: [authGuard] },
					{ path: 'settings-installer-ocpp', component: ChargerSettingsInstallerOcppComponent, canActivate: [authGuard] },
					{ path: '', redirectTo: 'status', pathMatch: 'full' }
				]
			},
			{ path: 'groups', component: MyGroupsComponent, canActivate: [authGuard] },
			{ path: 'history', component: SessionHistoryComponent, canActivate: [authGuard] },
			{ path: '', redirectTo: 'dashboard', pathMatch: 'full' }
		]
	},
	{ path: '**', component: NotFoundComponent }
];
